import PolarisIcon from '@/components/_common/PolarisIcon';
import { ButtonProps, IconButton, IconButtonProps, Tooltip } from '@mui/material';
import { SxProps } from '@mui/system';

interface RefreshProps {
  onClick: React.MouseEventHandler<HTMLButtonElement> | undefined;
  tooltipText?: string;
  color?: ButtonProps['color'];
  disabled?: ButtonProps['disabled'];
  sx?: SxProps;
  className?: any;
}

const Refresh = ({ onClick, tooltipText = 'Refresh Content', color = 'primary', disabled, sx, className }: RefreshProps) => {
  return (
    <Tooltip title={tooltipText}>
      <span>
        <IconButton data-testid="refresh-button" key={'refresh icon button'} size="small" onClick={onClick} color={color as IconButtonProps['color']} sx={sx} disabled={disabled}>
          <PolarisIcon icon="refresh" height={20} className={className} />
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default Refresh;
